<script setup lang="ts">
import {
	ScrollAreaScrollbar,
	type ScrollAreaScrollbarProps,
	ScrollAreaThumb,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = withDefaults(
	defineProps<ScrollAreaScrollbarProps & { class?: HTMLAttributes["class"] }>(),
	{
		orientation: "vertical",
	},
);

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ScrollAreaScrollbar
		v-bind="delegatedProps"
		:class="twMerge(
			'flex touch-none select-none transition-colors z-10',
			orientation === 'vertical' &&
				'h-full w-2.5 border-l border-l-transparent p-px',
			orientation === 'horizontal' &&
				'h-2.5 flex-col border-t border-t-transparent p-px',
			props.class,
		)"
	>
		<ScrollAreaThumb class="relative flex-1 rounded-full bg-foreground/25" />
	</ScrollAreaScrollbar>
</template>
